import React from "react";
import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";
const InspectionFormEditItems = lazyLoader(
  () =>
    import(
      "Containers/Inspections/InspectionsFormsDashboard/InspectionFormEdit/InspectionFormItemEdit/InspectionFormItemEdit"
    )
);

export const InspectionFormsItemsEditItemPage = () => {
  return (
    <Layout>
      <InspectionFormEditItems />
    </Layout>
  );
};
